"use strict";
/** @format */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
const x_date_pickers_pro_1 = require("@mui/x-date-pickers-pro");
const AdapterMoment_1 = require("@mui/x-date-pickers/AdapterMoment");
const x_date_pickers_1 = require("@mui/x-date-pickers");
const react_1 = __importDefault(require("react"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const DatePicker = (props) => (react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment },
    react_1.default.createElement(DateRangePicker, { ...props })));
function DateRangePicker(props) {
    const { timezone, value, onChange, ...dateRangePickerProps } = props;
    // @ts-ignore
    const [startValue, endValue] = value;
    // @ts-ignore
    const valueInTimezone = [toTimezone(startValue, timezone), toTimezone(endValue, timezone)];
    // If null or undefined is provided as a starting value, the callback
    // will not provide the selected range in the requested timezone, since
    // it uses the input to determine the timezone. So we force the timezone
    const handleChange = ([startRange, endRange], validationError) => {
        // Drop the attached timezone. Do not use the timezone force, as it has DST issues
        const rangeInTimezone = [
            replaceTimezone(startRange, timezone),
            replaceTimezone(endRange, timezone),
        ];
        onChange?.(rangeInTimezone, validationError);
    };
    return (react_1.default.createElement(x_date_pickers_1.LocalizationProvider, { dateAdapter: AdapterMoment_1.AdapterMoment },
        react_1.default.createElement(x_date_pickers_pro_1.DateRangePicker, { ...dateRangePickerProps, value: valueInTimezone, onChange: handleChange })));
}
exports.DateRangePicker = DateRangePicker;
// If we create a moment using null, the field will be flagged with an error
// So only convert defined values to a moment timezone object
function toTimezone(value, timezone) {
    if (value === null || value === undefined) {
        return value;
    }
    if (!timezone) {
        return value;
    }
    return moment_timezone_1.default.tz(value, timezone);
}
const DATE_ONLY_FORMAT = 'YYYY-MM-DD';
function replaceTimezone(value, timezone) {
    if (!value || !timezone) {
        return value;
    }
    // Print date and then re-parse in the expected timezone.
    // DO NOT USE keepLocale tz conversion it has known bugs with DST
    return moment_timezone_1.default.tz(value.format(DATE_ONLY_FORMAT), DATE_ONLY_FORMAT, timezone);
}
exports.default = DatePicker;
